import { render, staticRenderFns } from "./initUserId.vue?vue&type=template&id=2a59bb9b&scoped=true"
import script from "./initUserId.vue?vue&type=script&lang=js"
export * from "./initUserId.vue?vue&type=script&lang=js"
import style0 from "./initUserId.vue?vue&type=style&index=0&id=2a59bb9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59bb9b",
  null
  
)

export default component.exports